// 10/10/2026 (Luca, la A3): col carosello delle recensioni di Judge.me ridisegnato da gg-recensioni.css,
// (1) l'intestazione diventa «★★★★★ 4,98 · 169 recensioni verificate», coi numeri che il widget stesso ha appena scritto;
// (2) da computer le sue frecce fanno scorrere la fila (il CSS ha tolto la traslazione del suo script, che quindi non muoverebbe niente).
// Dal 27/10/2026 toccando una card si apre il popup nostro: è il blocco in fondo al file.
(function () {
  function intestazione(c) {
    if (c.dataset.ggRec) return;
    var t = c.querySelector('.jdgm-rating-text'), n = c.querySelector('.jdgm-reviews-count'), h = c.querySelector('.jdgm-header-info');
    if (!t || !n || !h) return;
    var voto = (t.textContent.match(/[0-9]+(?:[.,][0-9]+)?/) || [''])[0].replace('.', ','), quante = n.textContent.trim();
    if (!voto || !quante) return;
    h.innerHTML = '<div class="gr-voto"><span class="gr-stelle" aria-hidden="true">★★★★★</span> <b>' + voto + '</b> · ' + quante + ' recensioni verificate</div>';
    c.dataset.ggRec = '1';
  }
  function tutte() { document.querySelectorAll('.jdgm-cards-carousel').forEach(intestazione) }
  // in cattura: il clic non arriva all'onclick di Judge.me (jdgmPreviousCard/jdgmNextCard), la fila scorre di una card
  document.addEventListener('click', function (e) {
    var a = e.target.closest && e.target.closest('.jdgm-cards-carousel .jdgm-arrow');
    if (!a) return;
    var c = a.closest('.jdgm-cards-carousel'), w = c.querySelector('.jdgm-cards-wrapper');
    if (!w) return;
    e.preventDefault(); e.stopPropagation();
    var k = c.querySelector('.jdgm-card:not([data-clone-type])'), passo = (k ? k.getBoundingClientRect().width : 290) + 12;
    w.scrollBy({ left: a === c.querySelector('.jdgm-arrow') ? -passo : passo, behavior: 'smooth' });
  }, true);
  // 12/10/2026 (Luca, dal telefono: «il touch sulle recensioni è meccanico, non è fluido»): Judge.me ascolta il dito su .jdgm-content
  // (jdgmCarouselSwipe): oltre 10 px in orizzontale annulla il touchmove, che ferma lo scorrimento vero della fila, e a fine gesto sposta la
  // card attiva. La fila prende un ascoltatore che ferma il tocco prima che risalga a .jdgm-content: scorre solo col dito.
  // 27/10/2026 sera (Luca, dall'iPhone: «se resto nella pagina prodotto… e provo a scorrere per vederle una ad una, non riesco», su Crea il tuo
  // animaletto e Crea il tuo gioiello; in home, su Datti tempo e nel popup sì). Da qui, in Chrome e WebKit simulati, la fila scorre su tutte
  // le pagine: codice, stili, impostazioni di Judge.me, card ed elementi fissi sono identici, il blocco è di Safari vero e non si riproduce.
  // Rete di sicurezza: se il dito va in orizzontale per 30 px e la fila non si è mossa da sola, la muove lo script e alla fine si ferma sulla
  // card dove va il gesto. Dove lo scorrimento vero funziona la fila si muove prima dei 30 px e non cambia niente.
  function arma(w) {
    if (w.dataset.ggTocco) return;
    w.dataset.ggTocco = '1';
    var x0, y0, sl0, dx, verso, mano;
    w.addEventListener('touchstart', function (ev) {
      ev.stopPropagation();
      var p = ev.touches[0];
      x0 = p.clientX; y0 = p.clientY; sl0 = w.scrollLeft; dx = 0; verso = ''; mano = false;
    }, { passive: true });
    w.addEventListener('touchmove', function (ev) {
      ev.stopPropagation();
      var p = ev.touches[0], dy = p.clientY - y0;
      dx = p.clientX - x0;
      if (!verso && (Math.abs(dx) > 8 || Math.abs(dy) > 8)) verso = Math.abs(dx) > Math.abs(dy) ? 'x' : 'y';
      if (verso !== 'x') return;
      if (!mano && Math.abs(dx) > 30 && Math.abs(w.scrollLeft - sl0) < 2) { mano = true; w.style.scrollSnapType = 'none'; }
      if (mano) { if (ev.cancelable) ev.preventDefault(); w.scrollLeft = sl0 - dx; }
    }, { passive: false });
    ['touchend', 'touchcancel'].forEach(function (t) {
      w.addEventListener(t, function (ev) {
        ev.stopPropagation();
        if (!mano) return;
        mano = false;
        w.ggTrascinata = Date.now();
        // le posizioni delle card come le dà lo scroll-snap (scroll-padding a sinistra): parte da quella di partenza e va di una card
        // per ogni passo fatto col dito, almeno una se il gesto ha superato i 40 px
        var pad = parseFloat(getComputedStyle(w).scrollPaddingLeft) || 0, l = w.getBoundingClientRect().left;
        var pos = [].map.call(w.querySelectorAll('.jdgm-card:not([data-clone-type])'), function (c) { return w.scrollLeft + c.getBoundingClientRect().left - l - pad; });
        if (!pos.length) { w.style.scrollSnapType = ''; return; }
        var da = 0;
        pos.forEach(function (x, i) { if (Math.abs(x - sl0) < Math.abs(pos[da] - sl0)) da = i; });
        var passo = pos.length > 1 ? pos[1] - pos[0] : 300, n = Math.round(Math.abs(dx) / passo);
        if (Math.abs(dx) > 40) n = Math.max(1, n);
        var a = Math.max(0, Math.min(pos.length - 1, da + (dx < 0 ? n : -n)));
        w.scrollTo({ left: Math.max(0, pos[a]), behavior: 'smooth' });
        setTimeout(function () { w.style.scrollSnapType = ''; }, 500);
      }, { passive: true });
    });
  }
  document.addEventListener('touchstart', function (e) {
    var w = e.target.closest && e.target.closest('.jdgm-cards-carousel .jdgm-cards-wrapper');
    if (w) arma(w);
  }, { capture: true, passive: true });
  // dopo un trascinamento fatto dallo script il tocco non deve aprire il popup (che ascolta il clic sul documento, in cattura)
  window.addEventListener('click', function (e) {
    var w = e.target.closest && e.target.closest('.jdgm-cards-carousel .jdgm-cards-wrapper');
    if (w && w.ggTrascinata && Date.now() - w.ggTrascinata < 600) { e.preventDefault(); e.stopPropagation(); }
  }, true);
  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', tutte); else tutte();
  window.addEventListener('load', tutte);
})();

// 27/10/2026 (Luca, task 10 del post go live: «la seconda recensione… si apre male. Se clicco quella, poi non posso scorrere le altre: sono
// tutte tagliate»): toccando una card del carosello di Judge.me non si apre più il suo popup, che ritaglia la foto in un riquadro largo e basso
// e contiene solo la recensione toccata, ma il nostro: la foto intera e lo swipe da una recensione all'altra, tutte quelle del carosello.
// Testi, nomi, stelle e foto si leggono dalle card che Judge.me ha già scritto nella pagina: le recensioni nuove entrano da sole.
// In alto solo le frecce, senza «2 / 30»: il carosello ne tiene al massimo 30 (limite di Judge.me) e il numero faceva sembrare che
// fossero tutte (Luca: «sembra che abbiamo solo 20 recensioni»).
// Il nome del gioiello nella card resta un link, ma apre la scheda nella stessa finestra (Judge.me gli mette target="_blank");
// le card con un video aprono ancora il popup di Judge.me.
(function () {
  if (window.ggRv) return;
  window.ggRv = true;
  var rv, fila, prima, dopo, carosello, n = 0, aperto = false, storia = false, daFocus = null;
  function carte(c) { return [].slice.call(c.querySelectorAll('.jdgm-card:not([data-clone-type])')); }
  function testo(el) { return el ? el.textContent.trim() : ''; }
  function esc(s) { return String(s).replace(/[&<>"]/g, function (c) { return { '&': '&amp;', '<': '&lt;', '>': '&gt;', '"': '&quot;' }[c]; }); }
  function dati(card) {
    var img = card.querySelector('img'), foto = '';
    if (img) {
      // la foto più grande che Judge.me offre (srcset 480w, 1024w)
      var ss = (img.getAttribute('srcset') || '').split(',').map(function (s) { return s.trim().split(/\s+/)[0]; }).filter(Boolean);
      foto = ss.length ? ss[ss.length - 1] : (img.getAttribute('src') || '');
    }
    var a = card.querySelector('.jdgm-product-name a');
    return {
      foto: foto, testo: testo(card.querySelector('.jdgm-text')), nome: testo(card.querySelector('.jdgm-reviewer-name')),
      stelle: card.querySelectorAll('.jdgm-star.jdgm--on').length || 5, prodotto: testo(a), link: a ? a.getAttribute('href') : ''
    };
  }
  function slide(d) {
    return '<article class="gg-rv__slide' + (d.foto ? '' : ' gg-rv__slide--testo') + '">' +
      (d.foto ? '<div class="gg-rv__foto"><img data-src="' + esc(d.foto) + '" alt="La foto di ' + esc(d.nome) + '" decoding="async"></div>' : '') +
      '<div class="gg-rv__corpo"><div class="gg-rv__stelle" role="img" aria-label="' + d.stelle + ' stelle su 5">' + '★★★★★'.slice(0, d.stelle) + '</div>' +
      '<p class="gg-rv__testo">' + esc(d.testo) + '</p><p class="gg-rv__nome">' + esc(d.nome) + '</p>' +
      (d.link ? '<a class="gg-rv__link" href="' + esc(d.link) + '">Vedi ' + esc(d.prodotto) + ' ›</a>' : '') + '</div></article>';
  }
  function qui() { return fila.clientWidth ? Math.round(fila.scrollLeft / fila.clientWidth) : 0; }
  function carica(k) {
    var s = fila.children[k], img = s && s.querySelector('img[data-src]');
    if (img) { img.src = img.getAttribute('data-src'); img.removeAttribute('data-src'); }
  }
  function segna() {
    if (!aperto) return;
    var k = qui();
    prima.disabled = k <= 0; dopo.disabled = k >= n - 1;
    carica(k); carica(k + 1); carica(k - 1);
  }
  function vai(k) {
    k = Math.max(0, Math.min(n - 1, k));
    fila.scrollTo({ left: k * fila.clientWidth, behavior: 'smooth' });
  }
  function icona(d) { return '<svg viewBox="0 0 24 24" width="20" height="20" aria-hidden="true"><path d="' + d + '" fill="none" stroke="currentColor" stroke-width="2.2" stroke-linecap="round" stroke-linejoin="round"/></svg>'; }
  function costruisci() {
    rv = document.createElement('div');
    rv.className = 'gg-rv';
    rv.setAttribute('role', 'dialog'); rv.setAttribute('aria-modal', 'true'); rv.setAttribute('aria-label', 'Le recensioni');
    rv.innerHTML = '<div class="gg-rv__scatola"><div class="gg-rv__testa"><div class="gg-rv__nav">' +
      '<button type="button" class="gg-rv__prima" aria-label="Recensione prima">' + icona('M15 5l-7 7 7 7') + '</button>' +
      '<button type="button" class="gg-rv__dopo" aria-label="Recensione dopo">' + icona('M9 5l7 7-7 7') + '</button></div>' +
      '<button type="button" class="gg-rv__chiudi" aria-label="Chiudi">' + icona('M6 6l12 12M18 6L6 18') + '</button></div>' +
      '<div class="gg-rv__fila"></div></div>';
    document.body.appendChild(rv);
    fila = rv.querySelector('.gg-rv__fila');
    prima = rv.querySelector('.gg-rv__prima'); dopo = rv.querySelector('.gg-rv__dopo');
    prima.addEventListener('click', function () { vai(qui() - 1); });
    dopo.addEventListener('click', function () { vai(qui() + 1); });
    rv.querySelector('.gg-rv__chiudi').addEventListener('click', function () { chiudi(); });
    rv.addEventListener('click', function (e) { if (e.target === rv) chiudi(); }); // da computer, il fondo scuro intorno
    fila.addEventListener('scroll', function () { requestAnimationFrame(segna); }, { passive: true });
    window.addEventListener('resize', function () { if (aperto) fila.scrollLeft = qui() * fila.clientWidth; });
    document.addEventListener('keydown', function (e) {
      if (!aperto) return;
      if (e.key === 'Escape') chiudi();
      else if (e.key === 'ArrowRight') vai(qui() + 1);
      else if (e.key === 'ArrowLeft') vai(qui() - 1);
    });
    // il gesto «indietro» del telefono chiude il popup invece di lasciare la pagina
    window.addEventListener('popstate', function () { if (aperto) { storia = false; chiudi(true); } });
  }
  function apri(c, i) {
    if (!rv) costruisci();
    var tutte = carte(c).map(dati);
    n = tutte.length; carosello = c; daFocus = document.activeElement;
    fila.innerHTML = tutte.map(slide).join('');
    rv.classList.add('gg-rv--su');
    document.documentElement.classList.add('gg-rv-aperto');
    aperto = true;
    fila.style.scrollBehavior = 'auto';
    fila.scrollLeft = i * fila.clientWidth;
    fila.style.scrollBehavior = '';
    segna();
    if (history.pushState) { history.pushState({ ggRv: 1 }, ''); storia = true; }
    rv.querySelector('.gg-rv__chiudi').focus({ preventScroll: true });
  }
  function chiudi(daStoria) {
    if (!aperto) return;
    var k = qui();
    aperto = false;
    rv.classList.remove('gg-rv--su');
    document.documentElement.classList.remove('gg-rv-aperto');
    // la fila del carosello riparte dall'ultima recensione vista
    var card = carte(carosello)[k], w = card && card.closest('.jdgm-cards-wrapper');
    if (w) w.scrollLeft = card.offsetLeft - parseFloat(getComputedStyle(w).paddingLeft || 0);
    if (storia && !daStoria) { storia = false; history.back(); }
    if (daFocus && daFocus.focus) daFocus.focus({ preventScroll: true });
  }
  // in cattura, prima di Judge.me: il tocco sulla card apre il nostro popup e non arriva al suo
  document.addEventListener('click', function (e) {
    var card = e.target.closest && e.target.closest('.jdgm-cards-carousel .jdgm-card');
    if (!card || card.hasAttribute('data-clone-type')) return;
    var nome = e.target.closest('.jdgm-product-name a');
    if (nome) { nome.removeAttribute('target'); return; }
    if (card.querySelector('video, iframe')) return;
    var c = card.closest('.jdgm-cards-carousel'), i = carte(c).indexOf(card);
    if (i < 0) return;
    e.preventDefault(); e.stopPropagation(); e.stopImmediatePropagation();
    apri(c, i);
  }, true);
})();
